import { getCategoryForManager } from "../configuration/optimization/constants"
import type { MetricDirectoryEntry } from "../hooks/useMetricDirectory"

// Prefer entry.group_key when the backend catalog has one (renders backend-seeded
// groups like Observations); else fall back to the hardcoded manager→category map.
export function resolveMetricCategory(
  entry: MetricDirectoryEntry | undefined,
  metricManager: string | null | undefined,
): string {
  if (entry?.group_key) {
    return entry.group_key
  }
  return getCategoryForManager(metricManager ?? "")
}
